import { useApiClient } from '../lib/api-client.js';
import { useQuery } from '@tanstack/react-query';

/**
 * Fetches a paginated list endpoint with `limit=1` to cheaply read `pagination.total`.
 * Used for "X tours / Y attractions" stat cards on detail pages.
 *
 * @param endpoint - API path (e.g. `/tours`), query string appended automatically.
 * @param queryKey - TanStack Query cache key.
 * @param enabled - Skip the request when false. Defaults to true.
 */
function useStatCount(endpoint, queryKey, enabled = true) {
    const apiClient = useApiClient();
    return useQuery({
        queryKey: [...queryKey],
        queryFn: () => apiClient.get(`${endpoint}?limit=1`),
        enabled,
    });
}

export { useStatCount };
//# sourceMappingURL=useStatCount.js.map
